export default "__VITE_ASSET__06927435__"